import styles from './StatCard.module.scss';

type Props = {
  data: {
    label: JSX.Element | string;
    value: string | number;
  };
};

export function StatCard({ data }: Props) {
  return (
    <div className={styles.container}>
      <p className={styles.label}>{data.label}</p>
      <div className={styles.value}>{data.value}</div>
    </div>
  );
}
